// Власний набір іконок у стилі World Taekwondo (duotone).
// Сітка 24×24, лінія = currentColor (2px, заокруглена), акцент = клас `ti-a` (жовтий --tkd-icon-accent).
// Спеціальні заливки: ti-f (currentColor), ti-blue / ti-red (кути чунг / хонг), ti-gold / ti-silver / ti-bronze (медалі).

const OCT_OUT = '20.78,8.36 20.78,15.64 15.64,20.78 8.36,20.78 3.22,15.64 3.22,8.36 8.36,3.22 15.64,3.22';
const OCT_IN = '17.54,9.7 17.54,14.3 14.3,17.54 9.7,17.54 6.46,14.3 6.46,9.7 9.7,6.46 14.3,6.46';

const medal = (metal, n) => `
  <path class="ti-blue" d="M6.5 2h4l2.6 6.2-3.6 1.6z"/>
  <path class="ti-yellow" d="M17.5 2h-4l-2.6 6.2 3.6 1.6z"/>
  <path d="M6.5 2h4l2.4 5.8M17.5 2h-4l-2.4 5.8" stroke-width="1.4"/>
  <circle class="ti-${metal}" cx="12" cy="15" r="6.5"/>
  <circle cx="12" cy="15" r="4.6" class="ti-ring" stroke-width="1.2"/>
  <text x="12" y="17.6" class="ti-num" text-anchor="middle">${n}</text>`;

const ICONS = {
  /* ── Спорт / World Taekwondo ───────────────────────── */

  // Керугі: боковий удар ногою (ціль — жовте коло)
  kyorugi: `
    <circle class="ti-a" cx="18" cy="9.5" r="3.6"/>
    <circle cx="6" cy="4.8" r="2.1"/>
    <path d="M7 7.4l2.6 5.1M9.6 12.5L8 16.6l1 4.4h2.4M9.6 12.5l5.4-1.6 5.6-2"/>
    <path d="M7.8 9L4.5 11l1 1.8M8.4 9.3l3.2-.9 1-2"/>`,

  // Пумсе: стійка ап-кубі з ударом рукою
  poomsae: `
    <rect class="ti-a" x="9.6" y="11" width="4.8" height="2.4" rx=".8"/>
    <circle cx="12" cy="4.2" r="2.1"/>
    <path d="M12 6.5V13M12 8.6h7.4M12 8.6l-4 2 2 2.2"/>
    <path d="M12 13l-4.5 3.4L5.6 21M12 13l4.5 3 2.3 5"/>`,

  // Добок з поясом — спортсмен / спортсмени
  dobok: `
    <rect class="ti-a" x="6" y="13" width="12" height="2.8"/>
    <path d="M8 3L3.6 5.4 2 10.6l3 1L6 9v12h12V9l1 2.6 3-1-1.6-5.2L16 3"/>
    <path d="M8 3l4 6.2L16 3M12 9.2l-2.4 3.8M6 13h12M6 15.8h12M11 15.8l-1.2 3.9M13 15.8l1.2 3.9"/>`,

  // Пояс із вузлом — категорія
  belt: `
    <rect class="ti-a" x="2" y="8" width="20" height="4.4" rx="1"/>
    <rect x="2" y="8" width="20" height="4.4" rx="1"/>
    <rect x="9.4" y="6.6" width="5.2" height="7.2" rx="1.6" class="ti-knot"/>
    <path d="M10.4 13.8L8.2 21M13.6 13.8l2.2 7.2"/>`,

  // Октагон (майданчик WT) з кутами чунг / хонг — місце проведення
  arena: `
    <polygon class="ti-a" points="${OCT_IN}"/>
    <polygon points="${OCT_OUT}"/>
    <circle class="ti-blue" cx="8.6" cy="12" r="1.7"/>
    <circle class="ti-red" cx="15.4" cy="12" r="1.7"/>`,

  // Октагон з # — нумерація поєдинків
  numbering: `
    <polygon class="ti-a" points="${OCT_IN}"/>
    <polygon points="${OCT_OUT}"/>
    <path d="M10.5 8.6l-.9 6.8M14.4 8.6l-.9 6.8M8.4 10.6h7.4M8 13.4h7.4"/>`,

  // Турнірна сітка — жеребкування
  bracket: `
    <rect class="ti-a" x="16" y="9.5" width="5.5" height="5" rx="1.4"/>
    <path d="M2.5 5H8v5H2.5M2.5 14H8v5H2.5M8 7.5h4M8 16.5h4M12 7.5v9M12 12h4"/>
    <rect x="16" y="9.5" width="5.5" height="5" rx="1.4"/>`,

  // Кубик — автоматичне жеребкування
  dice: `
    <rect class="ti-a" x="3" y="3" width="18" height="18" rx="4.5"/>
    <rect x="3" y="3" width="18" height="18" rx="4.5"/>
    <circle class="ti-f" cx="8" cy="8" r="1.5"/>
    <circle class="ti-f" cx="12" cy="12" r="1.5"/>
    <circle class="ti-f" cx="16" cy="16" r="1.5"/>`,

  // Ваги для зважування (платформа)
  scale: `
    <path class="ti-a" d="M7.5 10.5a4.5 4.5 0 0 1 9 0z"/>
    <rect x="3" y="3.5" width="18" height="17" rx="4"/>
    <path d="M7.5 10.5a4.5 4.5 0 0 1 9 0zM12 10.5l2.2-2.6M8 16.5h8"/>`,

  // Рефері з піднятою рукою («каллйо») — суддівська колегія
  referee: `
    <circle class="ti-a" cx="17" cy="5" r="2.6"/>
    <circle cx="8.5" cy="5" r="2.1"/>
    <path d="M8.5 7.4v7.8M8.5 15.2L6.6 21M8.5 15.2l2 5.8M8.5 9.4l6.8-3M8.5 9.4L5 12.6"/>
    <path d="M7.4 10.4h2.2" stroke-width="1.2"/>`,

  // Акредитаційний бейдж
  badge: `
    <rect class="ti-a" x="8.5" y="9.5" width="7" height="6" rx="1.2"/>
    <path d="M8.6 2l3.4 4.5L15.4 2"/>
    <rect x="5" y="6.5" width="14" height="15" rx="2.2"/>
    <circle cx="12" cy="11.4" r="1.5"/>
    <path d="M9.6 15.2a2.6 2.6 0 0 1 4.8 0M8.5 18.4h7"/>`,

  // Медалі
  'medal-gold': medal('gold', 1),
  'medal-silver': medal('silver', 2),
  'medal-bronze': medal('bronze', 3),

  // Кубок
  trophy: `
    <path class="ti-a" d="M7 3.5h10V9a5 5 0 0 1-10 0z"/>
    <path d="M7 3.5h10V9a5 5 0 0 1-10 0zM7 5.5H4v1.6A3.4 3.4 0 0 0 7.4 10.5M17 5.5h3v1.6a3.4 3.4 0 0 1-3.4 3.4M12 14v3.5"/>
    <rect x="8" y="17.5" width="8" height="3.5" rx="1"/>
    <path d="M12 6.2l.8 1.6 1.7.2-1.3 1.2.4 1.7-1.6-.9-1.6.9.4-1.7-1.3-1.2 1.7-.2z" class="ti-f" stroke="none"/>`,

  // Грамота з печаткою
  diploma: `
    <circle class="ti-a" cx="16" cy="14.5" r="3"/>
    <path d="M14 17h-9a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v7"/>
    <path d="M7 8h10M7 11h5"/>
    <circle cx="16" cy="14.5" r="3"/>
    <path d="M14.4 17l-.9 4 2.5-1.3 2.5 1.3-.9-4"/>`,

  // Клуб / доджанг (дах у східному стилі)
  club: `
    <path class="ti-a" d="M2 10.2C6.5 9.6 9.4 7 12 3.5c2.6 3.5 5.5 6.1 10 6.7z"/>
    <path d="M2 10.2C6.5 9.6 9.4 7 12 3.5c2.6 3.5 5.5 6.1 10 6.7z"/>
    <path d="M5 10v10.5h14V10M10 20.5V15h4v5.5M2.5 20.5h19"/>`,

  // Спортсмени: хлопець / дівчина у добоку
  'athlete-boy': `
    <path class="ti-a" d="M5 21v-2.5A4.5 4.5 0 0 1 9.5 14h5a4.5 4.5 0 0 1 4.5 4.5V21z"/>
    <circle cx="12" cy="7.5" r="3.6"/>
    <path d="M5 21v-2.5A4.5 4.5 0 0 1 9.5 14h5a4.5 4.5 0 0 1 4.5 4.5V21M10 14l2 3.2 2-3.2"/>`,
  'athlete-girl': `
    <path class="ti-a" d="M5 21v-2.5A4.5 4.5 0 0 1 9.5 14h5a4.5 4.5 0 0 1 4.5 4.5V21z"/>
    <circle class="ti-f" cx="16.6" cy="4.4" r="1.9"/>
    <circle cx="12" cy="7.5" r="3.6"/>
    <path d="M5 21v-2.5A4.5 4.5 0 0 1 9.5 14h5a4.5 4.5 0 0 1 4.5 4.5V21M10 14l2 3.2 2-3.2"/>`,

  // Ручне жеребкування / перетягування
  hand: `
    <path class="ti-a" d="M8 14V6.5a1.5 1.5 0 0 1 3 0V11V4.5a1.5 1.5 0 0 1 3 0V11V5.5a1.5 1.5 0 0 1 3 0V12V8.5a1.5 1.5 0 0 1 3 0V14a7 7 0 0 1-7 7h-1a6 6 0 0 1-5-2.7l-2.6-3.8a1.6 1.6 0 0 1 2.6-1.8z"/>
    <path d="M8 14V6.5a1.5 1.5 0 0 1 3 0V11V4.5a1.5 1.5 0 0 1 3 0V11V5.5a1.5 1.5 0 0 1 3 0V12V8.5a1.5 1.5 0 0 1 3 0V14a7 7 0 0 1-7 7h-1a6 6 0 0 1-5-2.7l-2.6-3.8a1.6 1.6 0 0 1 2.6-1.8z"/>`,

  /* ── Люди ──────────────────────────────────────────── */
  user: `
    <circle class="ti-a" cx="12" cy="8" r="4"/>
    <circle cx="12" cy="8" r="4"/>
    <path d="M4.5 20.5a7.5 7.5 0 0 1 15 0"/>`,
  team: `
    <circle class="ti-a" cx="9" cy="8" r="3.6"/>
    <circle cx="9" cy="8" r="3.6"/>
    <path d="M2.5 20a6.5 6.5 0 0 1 13 0M15.5 4.6a3.5 3.5 0 0 1 0 6.8M18 14.2A6.5 6.5 0 0 1 21.5 20"/>`,

  /* ── Інформація ────────────────────────────────────── */
  stats: `
    <rect class="ti-a" x="10" y="5" width="4" height="15" rx="1"/>
    <path d="M3 20.5h18"/>
    <rect x="4" y="11" width="4" height="9" rx="1"/>
    <rect x="10" y="5" width="4" height="15" rx="1"/>
    <rect x="16" y="14" width="4" height="6" rx="1"/>`,
  calendar: `
    <path class="ti-a" d="M3 9.5V7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2.5z"/>
    <rect x="3" y="5" width="18" height="16" rx="2"/>
    <path d="M3 9.5h18M8 3v4M16 3v4"/>
    <circle class="ti-f" cx="8" cy="14" r="1.1"/><circle class="ti-f" cx="12" cy="14" r="1.1"/><circle class="ti-f" cx="16" cy="14" r="1.1"/>
    <circle class="ti-f" cx="8" cy="17.5" r="1.1"/><circle class="ti-f" cx="12" cy="17.5" r="1.1"/>`,
  location: `
    <path class="ti-a" d="M12 21.5s7-6.2 7-11.5a7 7 0 0 0-14 0c0 5.3 7 11.5 7 11.5z"/>
    <path d="M12 21.5s7-6.2 7-11.5a7 7 0 0 0-14 0c0 5.3 7 11.5 7 11.5z"/>
    <circle cx="12" cy="10" r="2.6"/>`,
  map: `
    <path class="ti-a" d="M9 4l6 2v14l-6-2z"/>
    <path d="M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2zM9 4v14M15 6v14"/>`,
  phone: `
    <path class="ti-a" d="M5 3.5h3.4l1.6 4.6-2.3 1.5a11 11 0 0 0 6.7 6.7l1.5-2.3 4.6 1.6V19a2 2 0 0 1-2 2A16.5 16.5 0 0 1 3 5.5a2 2 0 0 1 2-2z"/>
    <path d="M5 3.5h3.4l1.6 4.6-2.3 1.5a11 11 0 0 0 6.7 6.7l1.5-2.3 4.6 1.6V19a2 2 0 0 1-2 2A16.5 16.5 0 0 1 3 5.5a2 2 0 0 1 2-2z"/>`,
  section: `
    <path class="ti-a" d="M3 9h18v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <path d="M3 18V6a2 2 0 0 1 2-2h4.2l2 2.2H19a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM3 9h18"/>`,
  notes: `
    <rect class="ti-a" x="8.5" y="2.5" width="7" height="4" rx="1.2"/>
    <path d="M8.5 4.5H7a2 2 0 0 0-2 2V19a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6.5a2 2 0 0 0-2-2h-1.5"/>
    <rect x="8.5" y="2.5" width="7" height="4" rx="1.2"/>
    <path d="M8.5 11h7M8.5 14.5h7M8.5 18h4"/>`,
  file: `
    <path class="ti-a" d="M14 3v5h5z"/>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8zM14 3v5h5M8.5 13h7M8.5 16.5h5"/>`,
  list: `
    <circle class="ti-a" cx="5" cy="6.5" r="1.8"/><circle class="ti-a" cx="5" cy="12" r="1.8"/><circle class="ti-a" cx="5" cy="17.5" r="1.8"/>
    <path d="M10 6.5h10M10 12h10M10 17.5h10"/>`,
  ruler: `
    <path class="ti-a" d="M3 16L16 3l5 5L8 21z"/>
    <path d="M3 16L16 3l5 5L8 21zM7 12l2 2M10 9l2.5 2.5M13 6l2 2"/>`,
  history: `
    <circle class="ti-a" cx="12.5" cy="12" r="5.5"/>
    <path d="M3.6 13A9 9 0 1 0 6 6.2M3.5 3.5v4.2h4.2M12.5 8v4.2l2.8 1.8"/>`,

  /* ── Дії ───────────────────────────────────────────── */
  plus: `<path d="M12 5v14M5 12h14" stroke-width="2.2"/>`,
  close: `<path d="M6.5 6.5l11 11M17.5 6.5l-11 11" stroke-width="2.2"/>`,
  check: `<path d="M5 12.5l4.5 4.5L19 7.5" stroke-width="2.4"/>`,
  'check-circle': `
    <circle class="ti-a" cx="12" cy="12" r="9"/>
    <circle cx="12" cy="12" r="9"/>
    <path d="M8 12.3l2.8 2.8L16.2 9.6"/>`,
  'x-circle': `
    <circle class="ti-a" cx="12" cy="12" r="9"/>
    <circle cx="12" cy="12" r="9"/>
    <path d="M9 9l6 6M15 9l-6 6"/>`,
  edit: `
    <path class="ti-a" d="M4 20l1-4.6L15.6 4.8a2.1 2.1 0 0 1 3 3L8 18.4z"/>
    <path d="M4 20l1-4.6L15.6 4.8a2.1 2.1 0 0 1 3 3L8 18.4zM13.6 6.8l3 3"/>`,
  trash: `
    <path class="ti-a" d="M6 7h12l-1 13a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z"/>
    <path d="M4 7h16M9 7V4.5h6V7M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13M10 11v6M14 11v6"/>`,
  save: `
    <rect class="ti-a" x="7" y="13" width="10" height="8"/>
    <path d="M5 3h11l5 5v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zM8 3v5h7V3M7 21v-8h10v8"/>`,
  search: `
    <circle class="ti-a" cx="10.5" cy="10.5" r="6.5"/>
    <circle cx="10.5" cy="10.5" r="6.5"/>
    <path d="M15.5 15.5L21 21" stroke-width="2.2"/>`,
  print: `
    <rect class="ti-a" x="3" y="9" width="18" height="8" rx="2"/>
    <path d="M7 9V3h10v6M7 17H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2"/>
    <rect x="7" y="13.5" width="10" height="7.5" rx="1"/>`,
  download: `
    <path class="ti-a" d="M3 15v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4z"/>
    <path d="M12 3v12M7 10l5 5 5-5M3 15v4a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-4"/>`,
  refresh: `
    <path d="M20 11A8 8 0 0 0 5.2 7.5M4 3.5v4.4h4.4M4 13a8 8 0 0 0 14.8 3.5M20 20.5v-4.4h-4.4"/>`,
  reset: `
    <path d="M4 4v5h5"/><path d="M4.6 9A8 8 0 1 1 4 13"/>`,
  move: `
    <path d="M4 5v5a4 4 0 0 0 4 4h12M15 9l5 5-5 5"/>`,
  copy: `
    <rect class="ti-a" x="8" y="8" width="13" height="13" rx="2"/>
    <rect x="8" y="8" width="13" height="13" rx="2"/>
    <path d="M16 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3"/>`,
  settings: `
    <path d="M3 7h18M3 17h18"/>
    <circle class="ti-a" cx="9" cy="7" r="2.6"/><circle cx="9" cy="7" r="2.6"/>
    <circle class="ti-a" cx="15" cy="17" r="2.6"/><circle cx="15" cy="17" r="2.6"/>`,
  format: `
    <path d="M4 20L15 9M13.5 7.5l3 3"/>
    <path class="ti-a" d="M18 2.5l.9 1.9 1.9.9-1.9.9-.9 1.9-.9-1.9-1.9-.9 1.9-.9zM7 3l.7 1.4 1.4.7-1.4.7L7 7.2l-.7-1.4-1.4-.7 1.4-.7zM19.5 13l.7 1.4 1.4.7-1.4.7-.7 1.4-.7-1.4-1.4-.7 1.4-.7z"/>`,
  flask: `
    <path class="ti-a" d="M7.3 14h9.4l2.5 4.4a1.6 1.6 0 0 1-1.4 2.6H6.2a1.6 1.6 0 0 1-1.4-2.6z"/>
    <path d="M8.5 3h7M10 3v6L4.8 18.4A1.8 1.8 0 0 0 6.4 21h11.2a1.8 1.8 0 0 0 1.6-2.6L14 9V3M7.3 14h9.4"/>`,
  lock: `
    <rect class="ti-a" x="4.5" y="10.5" width="15" height="10.5" rx="2.2"/>
    <rect x="4.5" y="10.5" width="15" height="10.5" rx="2.2"/>
    <path d="M8 10.5V7.5a4 4 0 0 1 8 0v3M12 14.5v2.5"/>`,
  eye: `
    <path class="ti-a" d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/>
    <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/>
    <circle cx="12" cy="12" r="3"/>`,
  'eye-off': `
    <path d="M10.6 5.6A9.6 9.6 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17 17 0 0 1-2.4 3.2M6.6 6.6C4 8.3 2.5 12 2.5 12S6 18.5 12 18.5c1.9 0 3.5-.6 4.9-1.5M9.9 9.9a3 3 0 0 0 4.2 4.2M3 3l18 18"/>`,
  camera: `
    <path class="ti-a" d="M4 8h3l2-3h6l2 3h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"/>
    <path d="M4 8h3l2-3h6l2 3h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"/>
    <circle cx="12" cy="13.5" r="3.5"/>`,
  image: `
    <path class="ti-a" d="M3 17l5-5 4 4 3-3 6 6v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <circle cx="8.5" cy="8.5" r="1.8"/>
    <path d="M3 17l5-5 4 4 3-3 6 6"/>`,
  logout: `
    <path class="ti-a" d="M6 3.5h7v17H6a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1z"/>
    <path d="M14 3.5H6a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h8M11 12h10M17 8l4 4-4 4"/>`,
  warning: `
    <path class="ti-a" d="M10.3 4L2.6 17.5A2 2 0 0 0 4.3 20.5h15.4a2 2 0 0 0 1.7-3L13.7 4a2 2 0 0 0-3.4 0z"/>
    <path d="M10.3 4L2.6 17.5A2 2 0 0 0 4.3 20.5h15.4a2 2 0 0 0 1.7-3L13.7 4a2 2 0 0 0-3.4 0zM12 9.5v4"/>
    <circle class="ti-f" cx="12" cy="16.8" r="1.1"/>`,
  heart: `
    <path class="ti-heart" d="M12 20.5s-8.5-5-8.5-11A4.8 4.8 0 0 1 12 7a4.8 4.8 0 0 1 8.5 2.5c0 6-8.5 11-8.5 11z"/>`,
  loader: `
    <circle cx="12" cy="12" r="8.5" class="ti-track"/>
    <path d="M12 3.5A8.5 8.5 0 0 1 20.5 12" stroke-width="2.4"/>`,
  menu: `<path d="M4 6.5h16M4 12h16M4 17.5h16" stroke-width="2.2"/>`,

  /* ── Стрілки ───────────────────────────────────────── */
  'arrow-left': `<path d="M19 12H5M11 6l-6 6 6 6"/>`,
  'arrow-right': `<path d="M5 12h14M13 6l6 6-6 6"/>`,
  'arrow-down': `<path d="M12 5v14M6 13l6 6 6-6"/>`,
  'chevron-up': `<path d="M6 15l6-6 6 6" stroke-width="2.2"/>`,
  'chevron-down': `<path d="M6 9l6 6 6-6" stroke-width="2.2"/>`,
};

export const ICON_NAMES = Object.keys(ICONS);

const ATTRS = 'viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"';

// Рядок SVG для місць, де немає Vue-шаблону (наприклад, drag ghost у innerHTML)
export function iconSvg(name) {
  return `<svg class="tkd-icon tkd-icon--${name}" ${ATTRS}>${ICONS[name] || ''}</svg>`;
}

export default ICONS;
